import { render } from "./MobileHeader.vue?vue&type=template&id=1fd35b1a&scoped=true&ts=true"
import script from "./MobileHeader.vue?vue&type=script&lang=ts"
export * from "./MobileHeader.vue?vue&type=script&lang=ts"

import "./MobileHeader.vue?vue&type=style&index=0&id=1fd35b1a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd35b1a"]])

export default __exports__